import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  KeyboardAvoidingView,
} from 'react-native';
import {
  Button,
  Input,
  Text,
  Icon,
  // Header,
  Image,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import Header from '../../misc/Header';

// import infraConfig from '../../../config.json';
// import {
//   GoogleSignin,
//   statusCodes,
//   GoogleSigninButton,
// } from '../../../signin-google';
// import { GoogleLogin } from 'react-google-login';

import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import { emailValidation, passwordValidation } from '../../../modules/validation/User';
import google from '../../../assets/images/google.png';
// import AmplifyConfig from '../../../backends/AmplifyConfig';

const validationSchema = yupObject().shape({
  email: emailValidation,
  password: passwordValidation,
});

class SignInForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {};
  }

  componentDidMount() {
    // if (Platform.OS !== 'web') {
    //   GoogleSignin.configure({
    //     scopes: GoogleConfig.scopes, // what API you want to access on behalf of the user, default is email and profile
    //     webClientId: infraConfig.googleOAuthClientId, // ??? must be the prod one for mobile/firebase until there is a dev/non-prod firebase?
    //     // webClientId: Platform.OS === 'web' ? infraConfig.googleOAuthClientId : '375046527864-1eubq8t4i502dlt4tkco8t3h6vchnn4e.apps.googleusercontent.com', // must be the prod one for mobile/firebase until there is a dev/non-prod firebase
    //     offlineAccess: true, // if you want to access Google API on behalf of the user FROM YOUR SERVER
    //     hostedDomain: '', // specifies a hosted domain restriction
    //     loginHint: '', // [iOS] The user's ID, or email address, to be prefilled in the authentication UI if possible. [See docs here](https://developers.google.com/identity/sign-in/ios/api/interface_g_i_d_sign_in.html#a0a68c7504c31ab0b728432565f6e33fd)
    //     forceCodeForRefreshToken: true, // [Android] related to `serverAuthCode`, read the docs link below *.
    //     accountName: '', // [Android] specifies an account name on the device that should be used
    //     iosClientId: infraConfig.envName !== 'prod' ? '1071998717712-p8937li5bfgvop325ordibpomgeq1lgt.apps.googleusercontent.com' : '375046527864-7dt9h4u90p7viu4imi5odp3udl5d8i7q.apps.googleusercontent.com', // [iOS] optional, if you want to specify the client ID of type iOS (otherwise, it is taken from GoogleService-Info.plist)
    //   });
    // }
  }

  // TODO(clairbee)
  async handleSubmit(values, formikBag) {
    formikBag.setSubmitting(true);
    this.setState({ error: undefined });

    const { onSubmit } = this.props;
    const err = await onSubmit(values);
    if (err !== null) {
      // FIXME(clairbee): 'status' does not get updated. 'formikBag' might be stale.
      formikBag.setStatus(err);
      this.setState({ error: err });
    }

    formikBag.setSubmitting(false);
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    // status,
  }) => {
    const { history, redirect, signInGoogle } = this.props;
    const { error } = this.state;

    return (
      <KeyboardAvoidingView
        style={[
          styles.view.form,
          {
            backgroundColor: 'white',
            width: '100%',
            padding: 0,
            margin: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
          },
        ]}
        behavior="padding"
      >
        <Header
          name={translate('menu_signin')}
          hasCancel
          history={history}
        />

        <KeyboardAwareScrollView
          style={{
            flex: 1,
            width: '100%',
            margin: 0,
          }}
          contentContainerStyle={styles.form.containerScrollable}
        >
          {/* <View
            style={{
              flexDirection: 'row',
              paddingTop: 20,
              paddingBottom: 20,
            }}
          > */}
          {/* {(true || Platform.OS === 'web') ? ( */}
          <Button
            clear
            title={translate('login_with_google')}
            containerStyle={[styles.buttonfsf.primaryContainer, { marginVertical: 30 }]}
            buttonStyle={styles.buttonfsf.primary}
            titleStyle={styles.buttonfsf.primaryTitle}
            loading={isSubmitting}
            onPress={() => signInGoogle()}
            // leftIcon={google}
            icon={(
              <Image
                // width={32}
                // height={32}
                style={{
                  borderRadius: 8,
                  borderWidth: 2,
                  borderColor: 'white',
                  backgroundColor: 'transparent',
                  width: 32,
                  height: 32,
                  marginHorizontal: 8,
                }}
                source={google}
              />
            )}
          />

          {/* </KeyboardAwareScrollView>// <GoogleLogin
          //   clientId={GoogleConfig.authWebClientId}
          //   scope={GoogleConfig.scopes.join(' ')}
          //   redirectUri={`https://${infraConfig.cognitoDomain}.auth.${infraConfig.region}.amazoncognito.com/oauth2/idpresponse${redirect}`}
          //   // uxMode="redirect"
          //   buttonText={translate('login_with_google')}
          //   onSuccess={signInGoogle}
          //   onFailure={(result) => {
          //     console.log('result');
          //     console.log(result);
          //   }}
          //   cookiePolicy="single_host_origin"
          //   style={{
          //   }}
          // />
          // ) : (
          //   <GoogleSigninButton
          //     style={{ width: 192, height: 48, marginVertical: 30 }}
          //     size={GoogleSigninButton.Size.Wide}
          //     color={GoogleSigninButton.Color.Dark}
          //     onPress={() => {
          //       try {
          //         GoogleSignin.hasPlayServices().then(() => {
          //           GoogleSignin.signIn()
          //             .then((userInfo) => {
          //               // this.setState({ userInfoGoogle: userInfo });

          //               console.log('userInfo');
          //               console.log(userInfo);

          //               signInGoogle(userInfo);
          //             })
          //             .catch((err) => {
          //               console.log('err');
          //               console.log(err);
          //             });
          //         });
          //       } catch (err) {
          //         if (err.code === statusCodes.SIGN_IN_CANCELLED) {
          //           // user cancelled the login flow
          //           console.log('SIGN_IN_CANCELLED');
          //         } else if (err.code === statusCodes.IN_PROGRESS) {
          //           // operation (e.g. sign in) is in progress already
          //           console.log('IN_PROGRESS');
          //         } else if (err.code === statusCodes.PLAY_SERVICES_NOT_AVAILABLE) {
          //           // play services not available or outdated
          //           console.log('PLAY_SERVICES_NOT_AVAILABLE');
          //         } else {
          //           // some other error happened
          //           console.log('other error');
          //         }
          //       }
          //     }}
          //     // disabled={this.state.isSigninInProgress}
          //   />
          // ) */}
          {/* </View> */}

          <Text
            style={{
              paddingBottom: 20,
              alignSelf: 'center',
              textAlign: 'center',
            }}
          >
            {`―  ${translate('or')}  ―`}
          </Text>

          {/* FIXME(clairbee): 'status' does not get updated. 'formikBag' might be stale. */}
          {/* { status !== undefined && (
            <Text
              style={{
                color: 'red',
              }}
            >
              {status}
            </Text>
          )} */}
          {error !== undefined && (
            <Text
              style={{
                color: 'red',
              }}
            >
              {error}
            </Text>
          )}
          <Input
            label={translate('signin_email')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.email && errors.email ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            value={values.email}
            placeholder={translate('signin_email_placeholder')}
            autoCompleteType="email"
            textContentType="emailAddress"
            importantForAutofill="yes"
            leftIcon={(
              <Icon
                name="user"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            keyboardType="email-address"
            autoCapitalize="none"
            // autoFocus // the use of 'autoFocus' breaks the eperience of clicking on 'Sign In with Google'
            onChangeText={(value) => setFieldValue('email', value)}
            onBlur={() => setFieldTouched('email')}
            editable={!isSubmitting}
            errorMessage={touched.email && errors.email ? errors.email : undefined}
          />
          <Input
            label={translate('signin_password')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.password && errors.password ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            placeholder={translate('signin_password_placeholder')}
            autoCompleteType="password"
            textContentType="password"
            importantForAutofill="yes"
            leftIcon={(
              <Icon
                name="lock"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            secureTextEntry
            password
            autoCapitalize="none"
            value={values.password}
            onChangeText={(value) => setFieldValue('password', value)}
            onBlur={() => setFieldTouched('password')}
            editable={!isSubmitting}
            errorMessage={touched.password && errors.password ? errors.password : undefined}
          />
          <Button
            title={translate('menu_signin')}
            containerStyle={[styles.buttonfsf.primaryContainer, { marginTop: 30 }]}
            buttonStyle={styles.buttonfsf.primary}
            disabledStyle={styles.buttonfsf.primaryDisabled}
            titleStyle={styles.buttonfsf.primaryTitle}
            disabledTitleStyle={styles.buttonfsf.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
          <Button
            clear
            title={translate('signin_forgot')}
            containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
            buttonStyle={styles.buttonfsf.secondary}
            titleStyle={styles.buttonfsf.secondaryTitle}
            onPress={() => history.push(`/forgot${redirect}`)}
          />
          <Button
            clear
            title={translate('signin_signup')}
            containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
            buttonStyle={styles.buttonfsf.secondary}
            titleStyle={styles.buttonfsf.secondaryTitle}
            onPress={() => history.push(`/signup${redirect}`)}
          />
          {/* <Button
            clear
            title={translate('button_cancel')}
            containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
            buttonStyle={styles.buttonfsf.secondary}
            titleStyle={styles.buttonfsf.secondaryTitle}
            onPress={() => history.push('/ai-agents')}
          /> */}
        </KeyboardAwareScrollView>
      </KeyboardAvoidingView>
    );
  };

  render() {
    const { email, password } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={{ email, password }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

SignInForm.defaultProps = {
  redirect: '/',
};

SignInForm.propTypes = {
  redirect: PropTypes.string,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  onSubmit: PropTypes.func.isRequired,
  signInGoogle: PropTypes.func.isRequired,
};

export default SignInForm;
